package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_04_19_Day_1
import com.veldekar.components.logs.Log_2025_04_19_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-04-19")
@Composable
public fun Log_2025_04_19(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "🐸 Shimmer Eve 🧚‍♂️",
        ogTitle = "🐸 Shimmer Eve 🧚‍♂️",
        date = LocalDate(2_025, 4, 19),
        aiHint = "Image is a Star Wars meme reference Admiral Ackbar",
        ogDescription = "Tune in to watch the frog drop on this Shimmer Eve spectacular!",
        ogImage = "ai/2025-04-19.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-90", dateString = "Newgrowth 90")
        Log_2025_04_19_Day_1()
        SessionDayHeader(dayId = "shimmer-1", dateString = "Shimmer 1")
        Log_2025_04_19_Day_2()
    }
}
